import { styled } from '@mui/material/styles';
import SearchInput from './SearchInput';

const AppBarSearchInput = styled(SearchInput)(({ theme }) => ({
  '&.MuiTextField-root': {
    backgroundColor: theme.palette.Container.Bg,
    [theme.breakpoints.up('md')]: {
      '.MuiInputBase-root': {
        flexWrap: 'wrap',
        padding: 0,
        '.MuiInputBase-input': {
          width: 'auto',
          fontSize: theme.typography.caption.fontSize,
          flex: 1,
        },
      },
    },
  },
}));

export default AppBarSearchInput;
